import { render, staticRenderFns } from "./MinisiteResultsPickClassification.vue?vue&type=template&id=0cbf2796&"
import script from "./MinisiteResultsPickClassification.vue?vue&type=script&lang=js&"
export * from "./MinisiteResultsPickClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbf2796')) {
      api.createRecord('0cbf2796', component.options)
    } else {
      api.reload('0cbf2796', component.options)
    }
    module.hot.accept("./MinisiteResultsPickClassification.vue?vue&type=template&id=0cbf2796&", function () {
      api.rerender('0cbf2796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteResultsPickClassification.vue"
export default component.exports